import React, { ReactElement, ReactNode } from 'react';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { ReferencedProjectDTO } from '../../../../api/core';
import {
  ProjectSuggester,
  referencedProjectToSelectedProject,
  SelectedProject,
  selectedProjectToReferencedProject,
} from '../suggester/ProjectSuggester';
import { Panel } from '../layout/Panel';
import { Actions, MultiInputControls } from '../../../components/form/MultiInput/MultiInputControls';
import { InputGroup } from '../layout/InputGroup';

interface ReferencedProjectsProps {
  checkPermission: CheckPermissionFunction;
  projects: ReferencedProjectDTO[];
  onChange: (referencedProjects: ReferencedProjectDTO[]) => void;
  validation: ValidationResult;
  label: string;
  multiple: boolean;
  autoFocus: boolean;
}

export function ReferencedProjects(props: ReferencedProjectsProps): ReactNode {
  return (
    <Panel
      title={props.label}
      toggleable={true}>
      <MultiInputControls<ReferencedProjectDTO>
        canEdit={props.checkPermission().canWrite}
        lines={props.projects}
        onChange={props.onChange}
        addNew={(rows: ReferencedProjectDTO[]): number => rows.push(null)}
        max={props.multiple ? undefined : 1}
        renderLines={(project: ReferencedProjectDTO, onLineChange: (newValues) => void, actions: Actions, idx: number): ReactElement => {
          return (
            <InputGroup
              delete={{
                action: actions.delete,
                disabled: !props.checkPermission().canWrite,
              }}
            >
              <ProjectSuggester
                inputId={`referencedProjects`}
                autoFocus={props.autoFocus}
                value={(project ? [project] : []).map(referencedProjectToSelectedProject)}
                required={props.checkPermission('id').required}
                validation={props.validation.children[idx]}
                disabled={!props.checkPermission('id').canWrite}
                onChange={(selectedProjects: SelectedProject[]): void => onLineChange(selectedProjects.length > 0 ? selectedProjects.map(selectedProjectToReferencedProject).pop() : null)}
                multiple={false}
              />
            </InputGroup>
          );
        }}
      />
    </Panel>
  );
}
